export const siteName = '妖精视频';

export const aboutData = {
  title: '关于妖精视频',
  description: '妖精视频是领先的免费在线视频聚合平台，致力于为用户提供一站式高清观影体验。平台聚合西瓜视频免费、91视频网站等优质内容源，覆盖电视剧、电影、综艺、动漫等全品类资源，每日更新热门剧集与最新大片。我们采用先进的流媒体传输技术，确保即点即播不缓冲，无论是追剧党还是电影爱好者，都能在这里畅享流畅的高清画质与丰富的影视内容库。',
  features: ['海量高清资源', '即点即播不缓冲', '每日更新同步', '多端无缝切换'],
};

export const updatesData = [
  { date: '2026-07-30', title: '《长相思》第二季全集上线', tag: '热播剧', summary: '杨紫、张晚意主演古装神话剧，全40集高清上线，支持西瓜视频免费源流畅播放。' },
  { date: '2026-07-28', title: '《异人之下》剧场版独家首发', tag: '新片', summary: '国产动漫巨制，改编自超人气漫画，4K画质全网首播，91视频网站同步推荐。' },
  { date: '2026-07-25', title: '暑期档电影专题上线', tag: '专题', summary: '《封神第二部》《热辣滚烫》《飞驰人生2》等热门影片高清合集，一次看过瘾。' },
  { date: '2026-07-22', title: 'CDN加速节点全面升级', tag: '公告', summary: '新增华东、华南两大加速节点，播放缓冲时间缩短至0.3秒以内，观影更流畅。' },
  { date: '2026-07-20', title: '《庆余年》第三季预约开启', tag: '预告', summary: '张若昀领衔回归，即日起开放预约提醒，上线第一时间推送通知，不错过每一集。' },
  { date: '2026-07-18', title: '日韩剧场专区重磅上线', tag: '新功能', summary: '收录《泪之女王》《与恶魔有约》等热门韩剧，日剧经典同步更新，字幕组精校中字。' },
  { date: '2026-07-15', title: 'VIP画质免费开放体验', tag: '福利', summary: '限时活动：全站4K超清画质免费开放，无需注册直接观看，持续至8月15日。' },
  { date: '2026-07-12', title: '《三体》动画版第三季定档', tag: '定档', summary: '终于来了！8月1日正式上线，每周五更新两集，妖精视频同步首播。' },
  { date: '2026-07-10', title: '手机端播放器全面优化', tag: '优化', summary: '新版播放器支持手势控制亮度音量、倍速播放记忆、后台小窗播放等实用功能。' },
];

export const faqData = [
  {
    question: '妖精视频是否需要注册或付费？',
    answer: '完全不需要。妖精视频是免费在线视频平台，所有内容无需注册、无需付费即可直接观看。我们通过广告合作维持运营，为用户提供永久免费的观影服务。',
  },
  {
    question: '为什么播放不缓冲这么流畅？',
    answer: '妖精视频采用自研CDN智能调度系统，在全国部署多个加速节点，根据用户地理位置自动匹配最优线路。同时采用H.265高效编码技术，在保证高清画质的前提下大幅降低带宽需求，实现即点即播。',
  },
  {
    question: '平台上的影片来源是否合规？',
    answer: '妖精视频聚合的内容均来自西瓜视频免费、91视频网站等正规合作平台，所有影片均经过版权审核。我们严格遵守知识产权保护法律法规，为用户提供安全可靠的观看环境。',
  },
  {
    question: '手机端怎么观看？画质如何？',
    answer: '手机浏览器直接访问妖精视频即可，无需下载APP。播放器自适应屏幕尺寸，支持标清到4K超清多档画质切换，系统会根据您的网络状况智能推荐最佳画质。',
  },
  {
    question: '更新频率怎么样？会不会断更？',
    answer: '妖精视频每日更新，热播剧集与各平台同步上线。我们拥有专业的内容运营团队，确保热门资源及时上架。如遇特殊情况延迟，会通过站内公告提前通知。',
  },
  {
    question: '支持哪些设备和浏览器？',
    answer: '支持所有主流设备：PC（Windows/Mac/Linux）、手机（iOS/Android）、平板及智能电视。浏览器兼容Chrome、Safari、Edge、Firefox最新版本，推荐使用Chrome获得最佳体验。',
  },
];

export const mediaData = [
  {
    title: '热门推荐：最新古装剧合集',
    imageQuery: 'Ancient Chinese fantasy drama palace scene with flowing silk costumes dramatic lighting cinematic composition rich warm tones',
    tag: '古装剧场',
    views: '128.6万',
  },
  {
    title: '高能预警：悬疑烧脑片单',
    imageQuery: 'Dark moody cinema interior with red velvet seats mysterious spotlight on stage dramatic shadows noir atmosphere cinematic photography',
    tag: '悬疑推荐',
    views: '96.3万',
  },
  {
    title: '夏日特辑：喜剧电影大放送',
    imageQuery: 'Vibrant summer outdoor cinema under stars with colorful string lights joyful crowd atmosphere warm golden hour lighting cinematic wide shot',
    tag: '喜剧专场',
    views: '85.1万',
  },
  {
    title: '高分韩剧：必看精选',
    imageQuery: 'Korean drama romantic scene with cherry blossoms falling soft pastel lighting intimate emotional moment cinematic shallow depth of field beautiful composition',
    tag: '韩剧热播',
    views: '112.4万',
  },
  {
    title: '国产动漫：崛起之作',
    imageQuery: 'Chinese animation epic fantasy scene with mystical creatures floating mountains golden clouds dynamic lighting sweeping cinematic scale dramatic composition',
    tag: '国漫推荐',
    views: '73.8万',
  },
];

export const contactData = {
  title: '联系我们',
  description: '无论您有内容推荐、合作洽谈还是问题反馈，妖精视频团队始终欢迎您的来信。我们珍视每一位用户的建议，致力于打造更好的观影平台。',
  email: 'contact@yaojingvideo.com',
  qq: '1234567890',
  wechat: 'yaojingvideo',
};

export const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20professional%20headshot%20neutral%20background%20soft%20lighting%20natural%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '追剧小仙女',
    time: '2小时前',
    content: '终于找到能流畅看《长相思》的地方了！画质超清晰，进度条随便拖都不卡，比其它平台强太多了，已经安利给闺蜜群！',
    likes: 326,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20professional%20headshot%20clean%20background%20warm%20lighting%20friendly%20smile&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '电影发烧友阿杰',
    time: '5小时前',
    content: '资源更新真的快，院线刚下映没多久的片子这里就有了高清版。而且不用注册直接看，省心！唯一建议就是多加点纪录片。',
    likes: 218,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20woman%20portrait%20professional%20headshot%20neutral%20background%20soft%20natural%20lighting%20gentle%20expression%20casual%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '深夜看剧人',
    time: '8小时前',
    content: '每天晚上躺床上用手机看两集，不缓冲是真的爽。之前用其他网站转圈转到崩溃，妖精视频拯救了我的睡前时光。',
    likes: 187,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20aged%20man%20portrait%20professional%20headshot%20plain%20background%20studio%20lighting%20friendly%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '老李聊影视',
    time: '1天前',
    content: '作为影视博主，妖精视频是我找素材的首选。分类清晰，搜索精准，日韩剧场新上线的专区质量也很高，持续关注！',
    likes: 145,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20woman%20portrait%20professional%20headshot%20simple%20background%20bright%20lighting%20happy%20smile%20casual%20modern%20look&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '小丸子爱追番',
    time: '1天前',
    content: '国漫专区太良心了！《异人之下》剧场版刚出就能看，画质拉满。希望以后能有更多国产动画资源，支持国产！',
    likes: 203,
  },
];

export const carouselData = [
  {
    title: '暑期档热门大片专题',
    subtitle: '影院级观影体验',
    imageQuery: 'Epic summer blockbuster movie collage with dramatic explosions golden sunset sky cinematic wide screen composition powerful action scenes rich warm color palette',
    description: '《封神第二部》《热辣滚烫》《飞驰人生2》——三部年度话题大作，高清画质还原影院观感。',
  },
  {
    title: '日韩剧场：精选好剧',
    subtitle: '字幕组精校中字',
    imageQuery: 'Korean Japanese drama poster style with cherry blossoms and neon city lights romantic atmosphere soft cinematic lighting elegant composition emotional storytelling',
    description: '《泪之女王》《与恶魔有约》等热门韩剧一网打尽，经典日剧同步收录，追剧不间断。',
  },
  {
    title: '国漫崛起：必看神作',
    subtitle: '国产动画新高度',
    imageQuery: 'Chinese animation epic scene with ancient warriors mystical beasts floating islands dramatic clouds beautiful traditional art style cinematic lighting sweeping landscape',
    description: '从《哪吒》到《长安三万里》，国漫精品持续更新，《三体》动画版第三季即将上线。',
  },
  {
    title: '悬疑烧脑：高能片单',
    subtitle: '考验你的推理力',
    imageQuery: 'Mysterious detective scene with magnifying glass old books dim desk lamp shadows on wall film noir atmosphere rich textures cinematic moody lighting',
    description: '精心挑选悬疑佳作，烧脑剧情层层反转。配合高码率画质，每一个细节都不放过。',
  },
];

export const rankingData = [
  { rank: 1, title: '长相思 第二季', type: '古装剧', hot: '986万', trend: 'up', change: '↑2' },
  { rank: 2, title: '异人之下 剧场版', type: '动画', hot: '852万', trend: 'up', change: '↑5' },
  { rank: 3, title: '庆余年 第三季预告', type: '古装剧', hot: '791万', trend: 'up', change: '↑1' },
  { rank: 4, title: '封神第二部', type: '电影', hot: '734万', trend: 'down', change: '↓1' },
  { rank: 5, title: '泪之女王', type: '韩剧', hot: '689万', trend: 'up', change: '↑3' },
  { rank: 6, title: '三体 动画版第三季', type: '动画', hot: '652万', trend: 'new', change: 'NEW' },
  { rank: 7, title: '热辣滚烫', type: '电影', hot: '598万', trend: 'down', change: '↓2' },
];

export const appData = {
  title: '随时随地 畅享观影',
  description: '无需下载APP，手机浏览器打开即可观看。全平台自适应，支持iOS、Android、平板及智能电视。播放器支持手势控制、倍速播放、后台小窗等便捷功能，让你在任何设备上都能享受流畅高清的观影体验。',
  features: ['免安装即用', '全设备自适应', '手势快捷操作', '小窗后台播放'],
};

export const indexData = [
  { title: '古装剧场', icon: 'ri-vip-crown-line', count: '328部', desc: '仙侠、权谋、宫斗全收录' },
  { title: '悬疑探案', icon: 'ri-search-eye-line', count: '215部', desc: '高能反转烧脑不断' },
  { title: '都市情感', icon: 'ri-heart-pulse-line', count: '276部', desc: '甜宠虐恋应有尽有' },
  { title: '科幻奇幻', icon: 'ri-rocket-line', count: '163部', desc: '想象力无边界' },
  { title: '日韩专区', icon: 'ri-global-line', count: '442部', desc: '热门韩剧日剧一网打尽' },
  { title: '国产动漫', icon: 'ri-brush-line', count: '198部', desc: '国漫崛起必看推荐' },
  { title: '综艺娱乐', icon: 'ri-emotion-laugh-line', count: '387部', desc: '搞笑真人秀不间断' },
];

export const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '极速播放',
    desc: '自研CDN加速，即点即播不缓冲，拖拽进度条秒响应，告别等待焦虑。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持标清至4K超清多档切换，H.265高效编码，用最少流量看最清画面。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: 'PC、手机、平板、电视全平台覆盖，自适应屏幕尺寸，随时随地畅享观影。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无弹窗广告、无恶意跳转、无强制注册，纯净观影环境让您安心追剧。',
  },
];

export const topicsData = [
  { name: '长相思', count: '1,286万', color: 'bg-primary-500' },
  { name: '异人之下', count: '963万', color: 'bg-accent-500' },
  { name: '庆余年', count: '892万', color: 'bg-secondary-500' },
  { name: '封神第二部', count: '756万', color: 'bg-primary-400' },
  { name: '三体动画', count: '721万', color: 'bg-accent-400' },
  { name: '泪之女王', count: '658万', color: 'bg-secondary-600' },
  { name: '热辣滚烫', count: '612万', color: 'bg-primary-300' },
  { name: '飞驰人生2', count: '534万', color: 'bg-accent-300' },
  { name: '国漫崛起', count: '487万', color: 'bg-secondary-400' },
];

export const cardsData = [
  {
    title: '《长相思》全集高清热播中',
    imageQuery: 'Chinese fantasy drama ancient costume romantic scene with flowing silk warm candlelight atmospheric palace interior soft golden lighting cinematic composition',
    tag: '古装',
    desc: '杨紫张晚意主演，40集全高清上线，妖精视频热度榜TOP1。',
  },
  {
    title: '暑期悬疑片单：烧脑之旅',
    imageQuery: 'Mysterious crime scene investigation with evidence board red string connections dim lighting noir atmosphere cinematic framing tension and intrigue',
    tag: '悬疑',
    desc: '精选15部高能反转悬疑电影，考验你的推理能力，每一帧都是线索。',
  },
  {
    title: '韩剧《泪之女王》催泪上线',
    imageQuery: 'Korean drama emotional scene with rain city lights reflection on wet street melancholic mood soft blue tones cinematic anamorphic composition',
    tag: '韩剧',
    desc: '金秀贤金智媛领衔，收视率破纪录的现象级韩剧，催泪指数五颗星。',
  },
  {
    title: '国漫专区：《异人之下》首发',
    imageQuery: 'Chinese animation action scene with supernatural powers energy effects traditional ink painting style merged with modern animation dynamic composition',
    tag: '国漫',
    desc: '国产动画新标杆，全网首播4K版本，特效炸裂剧情紧凑不容错过。',
  },
  {
    title: '《三体》动画第三季倒计时',
    imageQuery: 'Science fiction space scene with three suns galaxy nebula cosmic scale dramatic astronomical phenomena cinematic sci-fi epic composition dark vast universe',
    tag: '科幻',
    desc: '8月1日正式上线，每周五更新两集。黑暗森林法则即将揭开面纱。',
  },
  {
    title: '经典港片修复版合集',
    imageQuery: 'Hong Kong cinema classic movie scene with neon signs narrow streets at night rain reflections retro atmosphere cinematic street photography warm nostalgic tone',
    tag: '经典',
    desc: '周星驰、成龙、周润发经典作品高清修复，重温港片黄金时代。',
  },
];